enum TipLocation {
    Start = "start",
    End = "end"
}

export default TipLocation;
